module.exports = __webpack_public_path__ + "static/media/stress-management@2x.b49208cf.png";